const teamPageES = {
	header: {
		title: "Equipo",
		subtitle: "Elige a alguien para editar su perfil y los servicios que ofrece.",
		inviteStaff: "Invitar personal",
		manageStaff: "Administrar personal",
	},
	stats: {
		active: "Activos",
		pending: "Pendientes",
		invited: "Invitados",
	},
	ownerCalendar: {
		label: "Tu calendario",
		on: "Los clientes pueden reservar citas contigo.",
		off: "Tú administras el negocio. Los clientes reservan con tu personal, no contigo.",
		turnOff: "No atiendo citas",
		turnOn: "Sí atiendo citas",
		working: "Actualizando…",
		pricingNote: "Se cobra por calendario, y el primero está incluido en tu plan.",
		onSuccess: "Listo — tu calendario está activo. Configura tus horarios en la pestaña Calendario.",
		offSuccess: "Listo — ya no apareces como reservable.",
		cancelledSuccess: "Listo — {{count}} cita(s) canceladas y tu calendario está desactivado. Ya avisamos por correo a esos clientes.",
		failed: "No pudimos actualizar tu calendario. Inténtalo de nuevo.",
		blocked: "Tienes {{count}} cita(s) próximas en tu calendario. Reasígnalas desde la pestaña Calendario, o cancélalas, antes de desactivarlo.",
		noCalendars: "Nadie en este negocio recibe reservas todavía. Invita a un miembro del personal o vuelve a activar tu calendario.",

		/* El paso de confirmación. Cada línea es algo que el dueño no puede ver desde
		   la tarjeta y que solo descubriría después — un horario borrado, un correo ya
		   enviado a un cliente, una línea de factura que cambió. */
		confirmOffTitle: "¿Desactivar tu calendario?",
		confirmOnTitle: "¿Activar tu calendario?",
		confirmOffSchedule: "Tus horarios, días libres y cambios puntuales se borran para siempre. Si lo vuelves a activar, empiezas con un calendario vacío.",
		confirmOffBookings: "Se cancelan todas las citas próximas de tu calendario. Primero te diremos cuántas son, para que puedas ir a reasignarlas antes de decidir.",
		confirmOffVisibility: "Dejas de aparecer en la página de tu negocio. Los clientes no podrán reservar contigo.",
		confirmOffNoCalendars: "Después de esto nadie en el negocio recibe reservas. Tu negocio sigue publicado, pero no se podrá reservar nada hasta que un miembro del personal esté activo, o vuelvas a activar tu calendario.",
		confirmOnSchedule: "Empiezas con un calendario vacío. Los clientes no podrán reservar contigo hasta que configures tus horarios en la pestaña Calendario.",
		confirmOnVisibility: "Aparecerás en la página de tu negocio como alguien con quien se puede reservar.",
		billingUp: "Un calendario facturable más. Se suma a tu próxima factura, no se cobra hoy.",
		billingDown: "Un calendario facturable menos. El ajuste aparece en tu próxima factura — hoy no hay reembolso.",
		billingIncluded: "Sin cargo extra — tu plan incluye el primer calendario del negocio.",
		billingSame: "Tu factura no cambia — el plan base cubre tu negocio, atiendas citas o no.",
		billingCapped: "Tu factura no cambia — tu plan cobra como máximo {{max}} calendarios y ya estás por encima.",
		billingPending: "Hoy no se cobra nada. El número se guarda y se aplica cuando tu suscripción esté activa.",
		confirmOff: "Desactivarlo",
		confirmOn: "Activarlo",

		/* El paso de cancelación — el único lugar de la app que cancela la cita
		   de otra persona por un ajuste. Lleva números reales en vez de "cualquier
		   cita próxima", porque a estas alturas el servidor ya las contó y ser
		   vago aquí es justo lo que hace que uno se arrepienta del clic. */
		cancelTitle: "¿Cancelar {{count}} cita(s) próximas?",
		cancelWhat: "Tienes {{count}} cita(s) todavía por delante. Desactivar tu calendario las cancela definitivamente — no hay forma de deshacerlo, y para recuperar una el cliente tendría que reservar de nuevo desde cero.",
		cancelEmails: "Avisamos por correo a cada uno de esos clientes de que su cita se canceló, para que nadie llegue a un calendario cerrado.",
		cancelReassignInstead: "¿Quieres conservarlas? Cierra esto, reasigna cada una a un miembro del equipo desde la pestaña Calendario y luego desactiva tu calendario.",
		cancelConfirm: "Cancelarlas y desactivar",
		keepThem: "Conservarlas",
		cancel: "Cancelar",
	},
	empty: {
		noStaff: "Aún no hay nadie en tu equipo",
		noStaffHint: "Invita a tu primer miembro del personal y aparecerá aquí.",
		selectTitle: "Selecciona un miembro del equipo",
		selectHint: "Elige a alguien de la lista para ver y editar su perfil.",
		noServicesHint: "Asigna servicios para que esta persona pueda recibir reservas.",
		notBookableTitle: "No atiende citas",
		notBookableHint: "Tú administras el negocio, así que no tienes servicios ni calendario. Puedes cambiarlo desde Tu calendario, arriba.",
	},
	messages: {
		activateFailed: "No pudimos activar este perfil. Inténtalo de nuevo.",
		noValidEmail: "Ingresa al menos un correo válido para continuar.",
		inviteFailed: "No pudimos enviar algunas invitaciones. Inténtalo de nuevo.",
		removeFailed: "No pudimos eliminar a este miembro. Inténtalo de nuevo.",
		removeSuccess: "Listo — {{name}} ya no forma parte de tu equipo.",
		promoteFailed: "No pudimos completar el ascenso. Inténtalo de nuevo.",
		demoteFailed: "No pudimos actualizar el rol. Inténtalo de nuevo.",
		reinviteFailed: "No pudimos reenviar la invitación. Inténtalo de nuevo.",
		cancelInviteFailed: "No pudimos cancelar la invitación. Inténtalo de nuevo.",
	},
	status: {
		active: "Activo",
		registered: "Registrado",
		invited: "Invitado",
		joined: "Registrado",
		notBookable: "No reservable",
	},
	main: {
		roster: "Personal",
		services: "Servicios",
		noServices: "No hay servicios asignados",
		launch: "Activar",
		active: "Activo",
		inactive: "Inactivo",
		homeService: "A domicilio",
		you: "Tú",
		profile: "Perfil",
		serviceType: {
			home: "A domicilio",
			online: "Online",
		},
	},
	labels: {
		bio: "Biografía",
		email: "Correo:",
		phone: "Teléfono:",
		emailShort: "Correo",
		phoneShort: "Teléfono",
		noPhone: "Sin teléfono",
		firstName: "Nombre",
		lastName: "Apellido",
		emailAddress: "Correo electrónico",
	},
	actions: {
		edit: "Editar",
		addStaff: "+ Agregar personal",
		saveClose: "Guardar y cerrar",
		sending: "Enviando...",
		removing: "Eliminando...",
		cancel: "Cancelar",
		confirm: "Confirmar",
		promoteToAdmin: "Promover a administrador",
		demoteToStaff: "Degradar a personal",
		reinvite: "Reenviar invitación",
		cancelInvite: "Cancelar invitación",
		removeStaff: "Eliminar",
	},
	confirm: {
		removeStaff: "¿Eliminar a este miembro del equipo?",
		popupTitle: "¿Eliminar a {{name}}?",
		popupSubtitle: "Esta acción no se puede deshacer.",
		cancelInviteTitle: "¿Cancelar la invitación de {{name}}?",
		cancelInviteSubtitle: "La persona ya no podrá unirse.",
		cancel: "Cancelar",
		confirm: "Confirmar",
		warningBookings:
			"Por favor revise las reservas próximas de este miembro del personal y reasígnelas si es necesario. Si se elimina este miembro del personal, todas las citas activas en su calendario se cancelarán automáticamente. ¿Está seguro de que desea continuar?",
	},
	role: {
		owner: "Propietario",
		admin: "Administrador",
	},

	toast: {
		promotedToAdmin: "¡Listo! {{name}} ahora es administrador.",
		demotedToStaff: "Se actualizó el rol de {{name}} a personal.",
		inviteResent: "¡Listo! Reenviamos la invitación.",
		inviteCancelled: "Cancelamos la invitación de {{name}}.",
		inviteSent:
			"¡Invitación enviada! El miembro del personal recibirá un correo para completar la configuración de su perfil. Aparecerá como activo en tu negocio una vez que la haya completado.",
	},

	editProfile: "Editar perfil",

	modal: {
		team: {
			description: "Invita personas, define quién puede administrar y elimina a quienes ya no están.",
			newInvite: "Nueva invitación",
			newInviteHint: "Recibirá un correo para unirse a tu equipo.",
		},
		info: {
			description: "Nombre y biografía tal como los verán los clientes.",
		},
		services: {
			description: "Marca todo lo que esta persona está capacitada para hacer.",
		},
		photo: {
			title: "Foto de perfil",
			description: "Una foto clara ayuda a los clientes a reconocer con quién reservan.",
			choose: "Elegir imagen",
			change: "Elegir otra",
			save: "Guardar foto",
			uploading: "Subiendo...",
			none: "No hay imagen seleccionada",
			invalid: "Ese archivo no es una imagen válida. Elige una foto.",
			failed: "No pudimos subir la imagen. Inténtalo de nuevo.",
			pickFirst: "Primero elige una imagen.",
		},
	},
};
export default teamPageES;
